<div class="filter-editor">
  <div class="filter-row" *ngFor="let row of rows; let i = index">
    <input type="text" placeholder="field path" [(ngModel)]="row.path" (change)="emitFilters()" />
    <select [(ngModel)]="row.operator" (change)="emitFilters()">
      <option *ngFor="let operator of operators" [value]="operator.key">{{operator.name}}</option>
    </select>
    <ng-container [ngSwitch]="row.operator">
      <select *ngSwitchCase="'exists'" [(ngModel)]="row.value" (change)="emitFilters()">
        <option value="true">true</option>
        <option value="false">false</option>
      </select>
      <input *ngSwitchCase="'custom'" type="text" class="value-input" placeholder='JSON, e.g. {"$gte": 0}' [(ngModel)]="row.value" (change)="emitFilters()" />
      <ng-container *ngSwitchDefault>
        <select [(ngModel)]="row.valueType" (change)="emitFilters()">
          <option *ngFor="let valueType of valueTypes" [value]="valueType">{{valueType}}</option>
        </select>
        <input *ngIf="row.valueType !== 'null'" type="text" class="value-input"
          [placeholder]="row.operator === 'in' || row.operator === 'nin' ? 'comma-separated values' : 'value'"
          [(ngModel)]="row.value" (change)="emitFilters()" />
      </ng-container>
    </ng-container>
    <button class="button remove-button" (click)="removeRow(i)">Remove</button>
  </div>

  <button class="button" (click)="addRow()">Add Filter</button>
</div>
